import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const otherSettingsApi = createApi({
  reducerPath: "otherSettingsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  tagTypes: ["OtherSettings"],

  endpoints: (builder) => ({
    // ✅ GET SETTINGS
    getOtherSettings: builder.query({
      query: () => ({
        url: "/other-settings",
        method: "GET",
      }),
      providesTags: ["OtherSettings"],
    }),

    // ✅ UPDATE SETTINGS
    updateOtherSettings: builder.mutation({
      query: (payload) => ({
        url: "/other-settings",
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["OtherSettings"],
    }),
  }),
});

export const {
  useGetOtherSettingsQuery,
  useUpdateOtherSettingsMutation,
} = otherSettingsApi;

export default otherSettingsApi;